module.exports = __webpack_public_path__ + "media/images/icon_web_chat-8087631a.png";